import { Menu, MenuButton } from "@headlessui/react";
import { AnimatePresence } from "framer-motion";
import React from "react";

import {
  DropdownElement,
  OptionsDropdownElement,
  OptionsDropdownItems,
} from "src/base-components/OptionsDropdown/OptionsDropdownItems";

type Props = {
  elements: OptionsDropdownElement[];
  buttonDataLoc?: string;
  placement?: "bottom start" | "bottom end";
  children: React.ReactNode;
  disabled?: boolean;
};

const getOnElementClick = (element: DropdownElement) => () => {
  element.action();
};

export const OptionsDropdown: React.FC<Props> = ({
  elements,
  buttonDataLoc,
  placement = "bottom end",
  children,
  disabled,
}) => {
  return (
    <Menu as="div">
      {({ open }) => (
        <>
          <MenuButton
            as="div"
            className="flex justify-center"
            data-loc={buttonDataLoc}
            disabled={disabled}
          >
            {children}
          </MenuButton>
          <AnimatePresence initial={false}>
            {open && (
              <OptionsDropdownItems
                elements={elements}
                getOnElementClick={getOnElementClick}
                placement={placement}
                static
              />
            )}
          </AnimatePresence>
        </>
      )}
    </Menu>
  );
};
